import { TextFieldTypes } from '@ionic/core';
import { IonIcon, IonInput, IonSpinner } from '@ionic/react';
import classNames from 'classnames';
import { send, sendSharp } from 'ionicons/icons';
import React from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';

import './FormInput.scss';

const iconMap = {
  default: send,
  domination: sendSharp,
  roleplay: send,
  'purple-gradient': send,
  primary: send,
};

const iconColorMap = {
  default: undefined,
  domination: 'white',
  roleplay: undefined,
  'purple-gradient': undefined,
  primary: undefined,
};

export const FormInput = React.forwardRef<
  HTMLIonInputElement,
  {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- accepts UseFormReturn for any form schema across call sites
    form: UseFormReturn<any>;
    disableButton?: boolean;
    isShowButton?: boolean;
    onSubmit(): void;
    name: string;
    placeholder: string;
    type?: TextFieldTypes;
    hidden?: boolean;
    TEST_ID?: string;
    loading?: boolean;
    className?: string;
    autoFocus?: boolean;
    maxLength?: number;
    theme?:
      | 'default'
      | 'domination'
      | 'roleplay'
      | 'purple-gradient'
      | 'primary';
    onFocus?: () => void;
    onBlur?: () => void;
  }
>(function FormInputComponent(
  {
    form,
    hidden = false,
    disableButton,
    isShowButton = true,
    onSubmit,
    name,
    placeholder,
    type = 'text',
    TEST_ID,
    loading,
    className,
    autoFocus,
    maxLength,
    theme = 'default',
    onFocus,
    onBlur,
  },
  inputRef,
) {
  return (
    <Controller
      control={form.control}
      name={name}
      render={({ field }) => (
        <div
          className={classNames(
            'form-input',
            'controls',
            {
              hidden,
              [theme]: theme !== 'default',
            },
            className,
          )}
        >
          <IonInput
            color="none"
            name={field.name}
            type={type}
            onIonInput={(event) => {
              const value = event.target.value;
              if (typeof value === 'string') {
                field.onChange(value);
              }
            }}
            onIonFocus={onFocus}
            onIonBlur={onBlur}
            maxlength={maxLength}
            onKeyUp={(e) => {
              const keyBoardKey = e.nativeEvent.key;
              if (keyBoardKey === 'Enter' && !disableButton) {
                onSubmit();
              }
            }}
            autoFocus={autoFocus}
            ref={inputRef}
            placeholder={placeholder}
            value={field.value}
            data-testid={TEST_ID}
          />

          {isShowButton && (
            <div className="actions">
              <button
                type="submit"
                disabled={disableButton || loading}
                onClick={onSubmit}
                data-testid="onboarding-name__btn-send"
                className={classNames('action-button', {
                  loading,
                  [theme]: theme !== 'default',
                })}
              >
                {loading ? (
                  <IonSpinner name="bubbles" />
                ) : (
                  <IonIcon icon={iconMap[theme]} color={iconColorMap[theme]} />
                )}
              </button>
            </div>
          )}
        </div>
      )}
    />
  );
});
